<template>
    <div>
        <v-chip color="purple" outlined small label
            style="position: fixed; top: 70px; right: 16px; z-index: 1000;">
            <v-icon left small>mdi-file-code-outline</v-icon>
            FormSubsidios.vue (adopción)
        </v-chip>
        <DialogoComDistrito ref="dialogoCom" />
        <v-overlay :value="loading">
            <v-container fill-height fluid>
                <v-row align="center" justify="center">
                    <v-col cols="12" md="12" class="d-flex row justify-center align-center">
                        <v-img src="@/assets/Logo-bt-06.png" width="480" class="animacion-logo"></v-img>
                    </v-col>
                    <v-progress-circular indeterminate size="84" width="8" color="white"
                        class="animacion-process ma-5"></v-progress-circular>
                </v-row>
            </v-container>
        </v-overlay>
        <ValidationObserver ref="obs" v-slot="{ invalid, handleSubmit }">
            <v-form name="formSubsidioAdopcion" v-model="valid" @submit.prevent="handleSubmit(iniciarTramite)">
                <v-card class="custom-card" flat>
                    <v-card-text class="ma-0 pa-0">
                        <v-alert v-if="mostrarMensaje" colored-border color="orange darken-3" border="left"
                            elevation="0" dense
                            class="rounded-0 font-weight-regular text-body-1 orange--text text--darken-3">
                            {{ (necesitaNota) ? mensajeNota : mensajeSubsidio }}
                        </v-alert>
                        <v-row>
                            <v-card-text class="font-weight-bold text-body-1 black--text">
                                INFORMACIÓN SOBRE HIJO/A
                            </v-card-text>
                        </v-row>
                        <ValidationObserver ref="datosBasicosObserver" v-slot="{ validate, valid }">
                            <v-row class="d-flex flex-column" v-if="(familiaresSubsidios.length !== 0)">
                                <ValidationProvider v-slot="v">
                                    <v-col class="mt-2">
                                        <v-select clearable :items="familiaresSubsidios" v-model="familiarSeleccionado"
                                            return-object chips deletable-chips multiple
                                            :item-text="item => `${item.nombres} ${item.apellido} | DNI: ${item.nrodoc}`"
                                            label="Seleccionar familiar" @change="capturarFamiliares"></v-select>
                                    </v-col>
                                </ValidationProvider>
                            </v-row>
                            <div>
                                <v-row v-for="(hijo, index) in familiar" :key="index">
                                    <v-col v-if="index > 0" cols="12" md="12">
                                        <v-divider></v-divider>
                                    </v-col>
                                    <v-col cols="10" md="10" class="my-2">
                                        <div class="font-weight-bold text-body-2 primary--text">
                                            HIJO/A {{ index + 1 }}
                                        </div>
                                    </v-col>
                                    <v-col class="d-flex justify-end align-end" v-if="index > 0">
                                        <v-btn fab small @click="eliminarHijo(index)" color="error" outlined>
                                            <v-icon>mdi-delete-outline</v-icon>
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <ValidationProvider rules="required|minmax:2,50|alpha_spaces" v-slot="v">
                                            <v-text-field dense v-model="hijo.pah_nombre" label="Nombres"
                                                :error-messages="v.errors[0]" :disabled="(infoFamiliar)"
                                                @input="hijo.pah_nombre = hijo.pah_nombre.toUpperCase()">
                                            </v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <ValidationProvider rules="required|minmax:2,50|alpha_spaces" v-slot="v">
                                            <v-text-field dense v-model="hijo.pah_apellido" type="text" label="Apellido"
                                                :error-messages="v.errors[0]" :disabled="(infoFamiliar)"
                                                @input="hijo.pah_apellido = hijo.pah_apellido.toUpperCase()">
                                            </v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="8" md="6">
                                        <ValidationProvider rules="required|minmax:7,8|numeric" v-slot="v">
                                            <v-text-field dense v-model="hijo.pah_nroDoc" type="number"
                                                hide-spin-buttons @input="hijo.pah_nroDoc = hijo.pah_nroDoc"
                                                label="Nro. DNI" :disabled="(infoFamiliar)"
                                                :error-messages="v.errors[0]" @keydown="preventArrowKeys">
                                            </v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="4" md="6">
                                        <ValidationProvider rules="required" v-slot="v">
                                            <v-select dense v-model="hijo.pah_sexo" :items="itemSexo" label="Sexo"
                                                :error-messages="v.errors[0]" :disabled="(infoFamiliar)">
                                            </v-select>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <ValidationProvider rules="required" v-slot="v">
                                            <v-autocomplete dense v-model="familiarOriginal[index].nacionalidad"
                                                @input="selectNacionalidad($event, index)" return-object
                                                :items="nacionalidades" item-value="id" item-text="desnacionalidad"
                                                label="Nacionalidad" :disabled="(infoFamiliar)"
                                                :error-messages="v.errors[0]">
                                            </v-autocomplete>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <ValidationProvider rules="required" v-slot="v">
                                            <v-select dense v-model="familiarOriginal[index].tipnacionalidad"
                                                :error-messages="v.errors[0]"
                                                @input="selectTipNacionalidad($event, index)" :disabled="(infoFamiliar)"
                                                :items="tipoNacionalidad" item-value="tna_id" return-object
                                                item-text="tna_destipnac" label="Tipo de nacionalidad">
                                            </v-select>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col>
                                        <ValidationProvider rules="required|menorDeEdad" v-slot="v">
                                            <v-text-field v-model="hijo.pah_fechaNac" :disabled="(infoFamiliar)" dense
                                                label="Fecha de nacimiento:" type="date"
                                                :error-messages="v.errors[0]"></v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" md="12">
                                        <ValidationProvider rules="required" v-slot="v">
                                            <v-select v-model="afiliado.pad_hijoFall" :items="hijoFallOptions"
                                                :disabled="(infoFamiliar)" item-text="text" item-value="value"
                                                label="Hijo Fallecido" dense></v-select>
                                        </ValidationProvider>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-10">
                                    <v-col>
                                        <ValidationProvider rules="required" v-slot="v">
                                            <v-text-field v-model="afiliado.pad_fechaSentencia" dense
                                                :disabled="(infoFamiliar)" label="Fecha de sentencia de adopción:"
                                                type="date" :error-messages="v.errors[0]"></v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-btn @click="addHijo" :disabled="(infoFamiliar)" small :loading="loading"
                                            color="primary lighten-1" class="pa-5" rounded>
                                            <v-icon class='mr-2'>mdi-account-plus-outline</v-icon>
                                            AGREGAR HIJO/A
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="12" class="d-flex justify-end">
                                        <v-btn v-if="infoFamiliar" color="primary" elevation="0" class="pa-5"
                                            :loading="loadBtn" @click="habilitarInformacionFam">
                                            <v-icon class="mr-2">mdi-refresh</v-icon>
                                            MODIFICAR INFORMACIÓN
                                        </v-btn>
                                        <v-btn v-else color="primary" elevation="0" class="pa-5" :loading="loadBtn"
                                            :disabled="!valid" @click="validarSubsidio">
                                            <v-icon class="mr-2">mdi-information</v-icon>
                                            VALIDAR INFORMACIÓN
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                        </ValidationObserver>
                        <v-row>
                            <v-col>
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row class="d-flex flex-row justify-center align-center">
                            <v-card-text class="font-weight-bold text-body-1 black--text ">
                                CUENTA DE ACREDITACIÓN
                            </v-card-text>
                        </v-row>
                        <ValidationObserver ref="datosCuentaObserver" v-slot="{ validate, valid }">
                            <v-row>
                                <v-col cols="12" md="12">
                                    <v-alert colored-border color="orange darken-3" border="left" elevation="0" dense
                                        class="rounded-0 font-weight-regular text-body-1 orange--text text--darken-3">
                                        Recordá que debés ser titular de la cuenta
                                    </v-alert>
                                </v-col>
                            </v-row>
                            <v-row v-if="mediosPagos.length !== 0">
                                <v-col cols="12" md="12">
                                    <v-select clearable chips deletable-chips v-model="medioSeleccionado"
                                        label="Seleccione cuenta" return-object
                                        :item-text="item => `CBU: ${item.deb_cbu1}${item.deb_cbu2}`"
                                        :items="mediosPagos" @change="capturarCuenta"></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="4">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-text-field dense v-model="afiliado.pad_nomYApeTitular" type="text"
                                            hide-spin-buttons label="Titular" :error-messages="v.errors" disabled
                                            @keydown="preventArrowKeys">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <ValidationProvider rules="required|length:22|numeric" v-slot="v">
                                        <v-text-field dense v-model="afiliado.pad_cbu" type="number" hide-spin-buttons
                                            label="CBU" :error-messages="v.errors" @keydown="preventArrowKeys"
                                            :disabled="infoCuenta">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <ValidationProvider rules="required|length:11|numeric" v-slot="v">
                                        <v-text-field dense v-model="afiliado.pad_cuit" type="number" hide-spin-buttons
                                            :disabled="infoCuenta" label="CUIT/CUIL" :error-messages="v.errors"
                                            @keydown="preventArrowKeys">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <!--
                                <v-col cols="12" md="12">
                                    <v-select v-model="selectedBancoCod" :items="bancos" label="Entidad bancaria"
                                        :disabled="codigoBanco" dense item-text="nombre" item-value="cod"></v-select>
                                </v-col>
                                -->
                                <v-col cols="12" md="12" class="d-flex justify-end">
                                    <v-btn v-if="infoCuenta" color="primary" elevation="0" class="pa-5"
                                        :loading="loadBtn" @click="habilitarInfoCuenta">
                                        <v-icon class="mr-2">mdi-refresh</v-icon>
                                        MODIFICAR CUENTA
                                    </v-btn>
                                    <v-btn v-else color="primary" elevation="0" class="pa-5" :disabled="!valid"
                                        :loading="loadBtnCuenta" @click="validarCbu">
                                        <v-icon class="mr-2">mdi-information</v-icon>
                                        VALIDAR CUENTA
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </ValidationObserver>
                        <v-row>
                            <v-col>
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-card-text class="font-weight-bold text-body-1 black--text ">
                                DOCUMENTACIÓN REQUERIDA:
                            </v-card-text>
                        </v-row>
                        <v-row class="d-flex flex-row align-end justify-start"
                            :class="($vuetify.breakpoint.smAndDown) ? 'justify-center' : 'justify-space-around'">
                            <InputButtonArchivo @fileSelected="handleFileSelected" op="sentenciaAdopcion"
                                label="SENTENCIA FIRME DE ADOPCIÓN" />
                            <InputButtonArchivo @fileSelected="handleFileSelected" op="comprobanteCbu"
                                label="COMPROBANTE DE CBU" />
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end align-center custom-card-actions-ha">
                        <v-btn color="primary" elevation="0" class="pa-5"
                            :disabled="invalid || !formValid || !(infoCuenta && infoFamiliar)" type="iniciarTramite">
                            <v-icon class="mr-2">mdi-send-outline</v-icon>
                            enviar trámite
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </ValidationObserver>
    </div>
</template>

<script>

import InputButtonArchivo from '@/components/inputs/InputButtonArchivo.vue';
import DialogoComDistrito from '@/components/dialogos/DialogoComDistrito.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapGetters, mapActions } from 'vuex';

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        InputButtonArchivo,
        DialogoComDistrito
    },
    watch: {
        'afiliado.pad_hijoFall'(newValue) {
            this.familiar[0].pad_hijoFall = newValue;
        },
        mostrarMensaje(newVal) {
            // Si mostrarMensaje es true, cambia pnc_soloNacimiento a "N"
            if (newVal) {
                //this.afiliado.pnc_soloNacimiento = "N";
            }
        },
    },
    mounted() {
        //this.afiliado.pad_remitirADistrito = this.user.distrito
        this.afiliado.pad_nroafi = this.nroafi
        this.afiliado.pad_nomYApeTitular = this.nombreApellido
        this.afiliado.pad_observaciones = ""
        //this.familiarOriginal.tipfamiliar = 3 //hijo
        if (this.user.cuil) (
            this.afiliado.pad_cuit = this.user.cuil
        )
        /*         this.afiliado.pad_cuit = this.user.cuil */
    },
    data() {
        return {
            loading: false,
            tipoSubsidio: 'adopcion',

            mostrarMensaje: false,
            mensajeSubsidio: 'Se agregó automáticamente a tu solicitud el Subsidio por Madre no Gestante, ya que cumplís con los requisitos para el mismo',
            mensajeNota: 'Si deseas agregar la solicitud para el Subsidio por Madre no Gestante fuera del plazo de 45 días, recordá tildar la nota que se encuentra al pie de página',

            titulo: '',
            tipo: '',
            width: '',
            icon: '',
            itemSexo: ['F', 'M', 'X'], // item select sexo
            selectedBancoCod: null,
            familiar: [
                {
                    pah_nombre: '',
                    pah_apellido: '',
                    pah_fechaNac: '',
                    pah_nroDoc: '',
                    pah_tipodoc: '1',
                    pah_sexo: '',
                }
            ],
            afiliado:
            {
                pad_nroafi: "",
                pad_fechaSentencia: "",
                pad_nomYApeTitular: "",
                pad_cbu: "",
                pad_cuit: "",
                pad_observaciones: "",

                pad_hijoFall: "N",
                /*           pad_cuentaCompartida: "N",
                pad_metodoAcreditacion: "D",
                pad_fechaSolicitud: "",
                pad_propietarioCuenta: "A",
                pad_cantHijos: 1,
                pad_otroTitular: "",
                pad_otroCuit: "",
                pad_apoderado: 1,
                pad_tipTitularCheque: "",
                pad_titularCheque: "",
                pad_requisitos: "N",
                pad_remitirADistrito: "",
                pad_observaciones: "" */
            },

            familiarOriginal: [
                {
                    id: '',
                    nroafi: "",
                    nombres: "",
                    apellido: '',
                    sexo: "",
                    tipdoc: 1,
                    nrodoc: "",
                    estadocivil: '',
                    nacionalidad: '',
                    tipnacionalidad: '',
                    tipfamiliar: 3,
                    fecnacim: "",
                    fecfallecido: "",
                    fecestadocivil: "",
                    discapacidad: "",
                    accion: "A"
                }
            ],
            ordenClaves: ['id', 'nroafi', 'apellido', 'nombres', 'sexo', 'tipdoc', 'nrodoc', 'estadocivil', 'nacionalidad', 'tipnacionalidad', 'tipfamiliar', 'fecnacim', 'fecfallecido', 'fecestadocivil', 'discapacidad', 'accion'],

            formValid: false,
            familiarSeleccionado: null,
            medioSeleccionado: null,

            infoFamiliar: false,
            infoCuenta: false,

            loadBtn: false,
            loadBtnCuenta: false,

            hijoFallOptions: [
                { text: 'Si', value: 'S' },
                { text: 'No', value: 'N' },
            ]
        }
    },

    methods: {
        ...mapActions('notificaciones', ['showSnack', 'hideSnack']),
        ...mapActions('subsidios', ['solicitarSubsidiosAdopcion', 'validarSubsidioAfiliado', 'solicitarSubsidiosMaternidadNoGestante']),
        ...mapActions('mediosDePago', ['validarCBU']),

        habilitarInformacionFam() {
            this.infoFamiliar = false
            this.mostrarMensaje = false
        },
        habilitarInfoCuenta() {
            this.infoCuenta = false
        },
        selectNacionalidad(value, index) {
            this.$set(this.familiarOriginal, index, {
                ...this.familiarOriginal[index],
                nacionalidad: value.id,
                desnacionalidad: value.desnacionalidad
            });
        },
        selectTipNacionalidad(value, index) {
            this.$set(this.familiarOriginal, index, {
                ...this.familiarOriginal[index],
                tipnacionalidad: value.tna_id
            });
        },
        /* 
                selectTipNacionalidad() {
                    this.familiarOriginal.tipnacionalidad = value.tna_id
                },
                selectNacionalidad() {
                    this.familiarOriginal.nacionalidad = value.id
                    this.familiarOriginal.desnacionalidad = value.desnacionalidad
                }, */
        // Captura familiar al seleccionarlo del item para mostrarlo en el formulario
        capturarFamiliares(item) {
            //this.infoFamiliar = item.length > 0
            if (item.length !== 0) {
                if (item.length > this.familiar.length) {
                    this.showSnack({
                        message: 'No se puede insertar hijo, presione en agregar hijo primero',
                        type: '400'
                    });
                    this.familiarSeleccionado = [];
                    return;
                }
                if (item.length > 0) {
                    // Asigna los datos solo si hay suficiente espacio en el array `hijos`
                    item.forEach((familiar, index) => {
                        if (index < this.familiar.length) {
                            // Actualiza solo los objetos ya existentes en `this.hijos`
                            this.$set(this.familiar, index, {
                                ...this.familiar[index],
                                pah_nombre: familiar.nombres,
                                pah_apellido: familiar.apellido,
                                pah_fechaNac: familiar.fecnacim,
                                pah_tipdoc: '1',
                                pah_nroDoc: familiar.nrodoc,
                                pah_sexo: familiar.sexo
                            });

                            // Actualiza también los datos de `familiarOriginal`
                            this.$set(this.familiarOriginal, index, {
                                ...this.familiarOriginal[index],
                                nacionalidad: familiar.nacionalidad, // Actualiza la nacionalidad
                                tipnacionalidad: familiar.tipnacionalidad, // Actualiza el tipo de nacionalidad
                            });
                        }
                    });
                } else {
                    // Si no hay ningún familiar seleccionado, limpia el array `hijos`
                    this.familiar = [];
                }
            }
        },


        async validarCbu() {
            this.loadBtnCuenta = true
            const resultado = await this.validarCBU({ cbu: this.afiliado.pad_cbu })
            if (resultado) this.infoCuenta = true
            this.loadBtnCuenta = false; // Desactivamos el loading al finalizar
        },
        async validarSubsidio() {
            this.loadBtn = true
            const promises = this.familiar.map(familiar => {
                const obj = {
                    nroafi: this.nroafi,
                    tipoSubsidio: this.tipoSubsidio,
                    fechaNacimiento: familiar.pah_fechaNac,
                    dniFamiliar: familiar.pah_nroDoc,
                    fechaSentencia: this.afiliado.pad_fechaSentencia,
                    fechaMatrimonio: ''
                };
                return this.validarSubsidioAfiliado(obj);
            });

            const results = await Promise.all(promises);
            this.loadBtn = false;

            if (!results.every(result => result === true)) {
                this.$refs.dialogoCom.abrirDialog()
            } else {
                this.infoFamiliar = true
                this.mostrarMensaje = true
            }
            this.loadBtn = false
        },
        handleFileSelected() {
            (this.sentenciaAdopcion.length !== 0) && (this.comprobanteCbu.length !== 0) ? this.formValid = true : this.formValid = false
        },
        obtenerFamiliarOrdenado() {
            return this.familiarOriginal.map(familiar => {
                const familiarOrdenado = {};
                this.ordenClaves.forEach(key => {
                    familiarOrdenado[key] = familiar[key];
                });
                return familiarOrdenado;
            });
        },
        /*  obtenerFamiliarOrdenado() {
             const familiarOrdenado = {};
             this.ordenClaves.forEach(key => {
                 familiarOrdenado[key] = this.familiarOriginal[key];
             });
             return familiarOrdenado;
         },
  */
        capturarCuenta(item) {
            this.infoCuenta = false
            if (item) {
                this.afiliado.pad_cbu = `${item.deb_cbu1}${item.deb_cbu2}`
                //  this.validarCBU({ cbu: this.afiliado.pad_cbu })
                this.afiliado.pad_nomYApeTitular = this.nombreApellido
                this.afiliado.pad_cuit = this.user.cuil
                this.selectedBancoCod = this.codigoBanco
            } else {
                this.afiliado.pad_cbu = ''
                this.afiliado.pad_nomYApeTitular = ''
                this.afiliado.pad_cuit = ''
                this.selectedBancoCod = ''
            }
        },
        /* 
                capturarCuenta(item) {
                    if (item) {
                        this.afiliado.pad_cbu = item.deb_cbucompleto
                        this.afiliado.pad_nomYApeTitular = item.deb_tit_nombre
                        this.afiliado.pad_cuit = this.user.cuil
                        this.selectedBancoCod = this.codigoBanco
                    } else {
                        this.afiliado.pad_cbu = ''
                        this.afiliado.pad_nomYApeTitular = ''
                        this.afiliado.pad_cuit = ''
                    }
                }, */

        formatDate(date) {
            if (!date) return null
            if (date.includes('/')) {
                const [year, month, day] = date.split('/')
                return `${day}-${month}-${year}`
            } else {
                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            }
        },
        handlePaste(e) {
            e.preventDefault();
            this.showSnack({
                message: 'No esta permitido copiar y pegar',
                type: '500'
            })
        },
        async iniciarTramite() {
            try {
                this.loading = true
                // await this.validarSubsidio()
                this.familiarOriginal = this.familiarOriginal.map((familiarObj, index) => {
                    if (familiarObj.accion == 'A') {
                        // Obtiene los datos de afiliado y familiar (index usado para recorrer familiar)
                        return {
                            id: 0,
                            nroafi: this.afiliado?.pad_nroafi || "",
                            apellido: this.familiar[index]?.pah_apellido || "",
                            nombres: this.familiar[index]?.pah_nombre || "",
                            sexo: this.familiar[index]?.pah_sexo || "",
                            tipdoc: this.familiar[index]?.pah_tipodoc || 1,
                            nrodoc: this.familiar[index]?.pah_nroDoc || "",
                            estadocivil: "",
                            nacionalidad: familiarObj.nacionalidad || "",
                            tipnacionalidad: familiarObj.tipnacionalidad || "",
                            tipfamiliar: 3,
                            fecnacim: this.familiar[index]?.pah_fechaNac || "",
                            fecfallecido: "", // Dejar vacío si no se asigna un valor específico
                            fecestadocivil: "", // Asegura que esté vacío
                            discapacidad: "N", // Dejar vacío si no se asigna un valor específico
                            accion: "A"
                        };
                    }
                    // Retorna el objeto original si no cumple con accion === 'A'
                    return familiarObj;
                });
                //Si el conyuge/conviviente es nuevo seteo el familiar con id: 0 y las claves correspondientes para insertar
                console.log(this.familiarOriginal)
                const result = this.$refs.obs.validate()
                if (result) {
                    //this.copiarClaves()
                    const datosOrdenados = this.obtenerFamiliarOrdenado()
                    //const datosOrdenados = this.obtenerFamiliarOrdenado()
                    const formData = new FormData()
                    formData.append('afiliado', JSON.stringify(this.afiliado))
                    formData.append('familiar', JSON.stringify(this.familiar))
                    //familiarOriginal array de object
                    formData.append('familiarOriginal', JSON.stringify(datosOrdenados))
                    formData.append('archivo1', this.sentenciaAdopcion[0])
                    formData.append('archivo2', this.comprobanteCbu[0])
                    //formData.append('archivo3', this.dniFrenteFamiliar[0])
                    //formData.append('archivo4', this.dniDorsoFamiliar[0])
                    formData.forEach((value, key) => {
                        console.log(`Campo: ${key}, Valor:`, value);
                    });
                    await this.solicitarSubsidiosAdopcion(formData)
                } else {
                    console.log('Formulario inválido, no se puede enviar la petición');
                }
            } catch (error) {
                console.error("Ocurrió un error durante el proceso:", error);
            } finally {
                this.loading = false
                this.$emit('handleDialog')
            }
        },
        iniciarbaTramite() {
            let vm = this
            this.$refs.obs.validate().then(result => {
                if (result) {
                    const formData = new FormData()
                    formData.append('afiliado', JSON.stringify(this.afiliado))
                    formData.append('familiar', JSON.stringify(this.familiar))
                    formData.append('archivo1', this.sentenciaAdopcion[0])
                    formData.append('archivo2', this.comprobanteCbu[0])
                    // Imprimir todo el contenido del formData
                    formData.forEach((value, key) => {
                        console.log(`Campo: ${key}, Valor:`, value);
                    });
                    this.validarSubsidio()
                    vm.solicitarSubsidiosAdopcion(formData)

                } else {
                    console.log('Formulario inválido, no se puede enviar la petición');
                }
            });
        },
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
        isObject(value) {
            return (
                typeof value == 'object' &&
                value !== null &&
                !Array.isArray(value)
            )
        },
        addHijo() {

            const obj = {
                pah_nombre: '',
                pah_apellido: '',
                pah_sexo: '',
                pah_fechaNac: '',
                pah_tipdoc: '1',
                pah_nroDoc: '',
            }

            const objFamOrigin = {
                id: '',
                nroafi: "",
                nombres: "",
                apellido: '',
                sexo: "",
                tipdoc: 1,
                nrodoc: "",
                estadocivil: '',
                nacionalidad: '',
                tipnacionalidad: '',
                tipfamiliar: 3,
                fecnacim: "",
                fecfallecido: "",
                fecestadocivil: "",
                discapacidad: "",
                accion: "A"
            }
            this.familiar.push(obj)
            this.familiarOriginal.push(objFamOrigin)
        },

        eliminarHijo(index) {
            this.familiar.splice(index, 1)
            this.familiarOriginal.splice(index, 1)
        },


        /*  validarSubsidio() {
 
             const obj = {
                 nroafi: this.nroafi,
                 tipoSubsidio: 'adopcion',
                 fechaNacimiento: this.familiar.pah_fechaNac,
                 dniFamiliar: this.familiar.pah_nroDoc,
                 fechaSentencia: this.familiar.fechaSentencia,
                 fechaMatrimonio: ''
             };
 
             this.validarSubsidioAfiliado(obj)
 
         }, */



    },
    computed: {
        ...mapGetters('dataUser', ['sentenciaAdopcion', 'comprobanteCbu']),
        ...mapGetters('subsidios', ['familiaresSubsidios', 'mediosPagos', 'necesitaNota']),
        ...mapGetters('auth', ['user', 'nroafi', 'isAuthenticated']),
        ...mapGetters('mediosDePago', ['bancos', 'codigoBanco']),
        ...mapGetters('common', ['tipoNacionalidad', 'estadoCivil', 'tiposFamiliares', 'nacionalidades']),

        nombreApellido() {
            return `${this.user.nombres} ${this.user.apellido}`
        }
    },
    props: {
        tipo: {
            type: Number,
            required: true
        },

    }

}
</script>

<style>
/* Aplicamos el estilo para ajustar el tamaño del texto */
.v-list-item__subtitle {
    white-space: normal;
}

.custom-card {
    position: relative;
    height: 100%;
    cursor: default;
    padding-bottom: 80px;
    /* Espacio suficiente para las acciones */
}

.custom-card-actions-ha {
    position: fixed;
    /* Fijo en la parte inferior */
    bottom: 0;
    left: 0;
    right: 0;
    height: 65px;
    /* Ajusta la altura según sea necesario */
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    /* Asegúrate de que esté por encima del contenido */
}
</style>